'use client';

import { createTheme, ThemeOptions } from '@mui/material/styles';
import responsiveBaseTheme from '@/styles/brands/base';
import deepmerge from '@mui/utils/deepmerge';

const ilc_us = createTheme(
	deepmerge(responsiveBaseTheme, {
		palette: {
			primary: {
				main: 'rgba(0, 38, 86, 1)', //#002656
			},
			secondary: {
				main: 'rgba(239, 75, 37, 1)', //#EF4B25
			},
			accent: {
				main: 'rgba(244,245,247, 1)', //#F4F5F7
			},
			lightAccent: {
				main: 'rgba(244, 245, 247, 1)', //#F4F5F7
			},
			lightBackground: {
				main: 'rgba(244, 245, 247, 1)', // #F4F5F7
			},
		},
		components: {
			MuiButton: {
				styleOverrides: {
					contained: () => ({
						boxShadow: 'none',
						'&:hover': {
							backgroundColor: 'rgba(51,81,120, 1)', //#335178
						},
						'&:focus': {
							backgroundColor: 'rgba(84,110,142, 1)', //#546E8E
						},
						'&:active': {
							backgroundColor: 'rgba(84,110,142, 1)', //#546E8E
						},
					}),
				},
			},
			MuiFab: {
				styleOverrides: {
					root: {
						boxShadow: 'none',
						'&:hover': {
							backgroundColor: 'rgba(51,81,120, 1)', //#335178
						},
						'&:focus': {
							backgroundColor: 'rgba(84,110,142, 1)', //#546E8E
						},
						'&:active': {
							backgroundColor: 'rgba(84,110,142, 1)', //#546E8E
						},
					},
				},
			},
		},
	} as ThemeOptions),
);

export default ilc_us;
